import "./App.css";
import {  BrowserRouter as Router, Route, Routes,  Navigate } from "react-router-dom";

import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/AboutSection";
import Footer from "./pages/Footer";
import AboutAmbassador from "./pages/AboutAmbassador";
import FAQSection from "./pages/FAQSection";
import ContactUs from "./pages/ContactUs";
import CareerPage from "./pages/CareerPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { Box, useTheme } from "@mui/material";
import TermsOfUse from "./pages/TermsOfUse";
import ScrollToTop from "./utils/ScrollToTop";
import Loader from "./utils/Loader";


function App() {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [activeLink, setActiveLink] = useState("/Home");
   


  
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust the duration as needed

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.paper,
      }}>
      {loading ? (
        <Loader />
      ) : (
        <Router >
          <Navbar  activeLink={activeLink} setActiveLink={setActiveLink}  />
          <Box
            sx={{
              flex: 1,
            }}>
            <ScrollToTop />
            
            <Routes>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<Home />} />
              <Route path="/ambassador" element={<AboutAmbassador />} />
              <Route path="/faq" element={<FAQSection />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/careers" element={<CareerPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              
            </Routes>
          
          </Box>
          <Footer  activeLink={activeLink} setActiveLink={setActiveLink} />
        </Router>
      )}
    </Box>

    // <Box
    //   sx={{
    //     display: "flex",
    //     flexDirection: "column",
    //     minHeight: "100vh", // Ensures the app takes the full viewport height
    //     backgroundColor: theme.palette.background.paper,
    //   }}
    // >
    //   <Router>
    //     <Navbar />
    //     <Box
    //       sx={{
    //         flex: 1, // Makes this Box grow to fill the available space
    //       }}
    //     >
    //          <ScrollToTop />
    //       <Routes>
    //         <Route path="/" element={<HeroSection />} />
    //         <Route path="/about" element={<AboutSection />} />
    //         <Route path="/ambassador" element={<AboutAmbassador />} />
    //         <Route path="/faq" element={<FAQSection />} />
    //         <Route path="/contact" element={<ContactUs />} />
    //         <Route path="/careers" element={<CareerPage />} />
    //         <Route path ="/privacy-policy" element={<PrivacyPolicy/>} />
    //         <Route path ="/terms-of-use" element={<TermsOfUse/>} />
    //       </Routes>
    //     </Box>
    //     <Footer />
    //   </Router>
    // </Box>
  );
}

export default App;
